import { Size } from "@blueprintjs/core"
import { ITableRow, TableContent } from "src/modules/pe-landing-module/data/interfaces"
import { IPrimitiveProps } from "../section/Primitive"
import TableThread from "./table/TableThread"
import TableTr from "./table/TableTr"

/* Protopia Ecosystem component */ 
const TablePrimitive = (props: IPrimitiveProps): JSX.Element => { 
    const primitive: TableContent = (props.primitive) as any
    const data: ITableRow[]  = ( primitive.data || [])
     
    if( !Array.isArray(data)  || !data.length ) {
        return <></>
    } 
    
    return <div className='table-primitive-container'>
        <table className={`w-100 table ${primitive.className} table-${primitive.design_type} table-${ primitive.size || Size.MEDIUM } ${ primitive.striped ? "table-striped" : "" }  ${ primitive.hover ? "table-hover" : "" }  ${ primitive.bordered ? "table-bordered" : "" }`}>
            <TableThread section={ primitive.section } primitive={ primitive } /> 
            {
                data.map((row, i) => { 
                        return <TableTr
                            primitive={primitive}
                            key={ row.id || i }                           
                            i={i} 
                            threadData={ primitive.threads } 
                            row={ row }
                            animated={primitive.animated}
                            animated_delay={primitive.animated_delay} 
                            section={primitive.section}                       
                        /> 
                    })
            }
        </table>
    </div> 
}
export default TablePrimitive
